const isProduction = import.meta.env.VITE_ENVIRONMENT === 'production';

export const SEO_CONFIG = {
  siteName: 'The Redd Family Association',
  siteUrl: (import.meta.env['VITE_SITE_URL'] as string | undefined) ?? 'https://thereddfamily.org',
  isProduction,
  defaultDescription:
    'The Redd Family Association - Celebrating our West African heritage and preserving our family legacy since 2005',
  defaultOgImage: '/images/family-hero.jpeg',
  themeColor: '#92400e',
};

export interface PageMeta {
  readonly title: string;
  readonly description: string;
}

export const PAGE_META = {
  '/': {
    title: 'The Redd Family Association | Celebrating Our Heritage',
    description:
      'The Redd Family Association - Celebrating our West African heritage and preserving our family legacy since 2005. Join us for reunions, events, and family connections.',
  },
  '/about': {
    title: 'About Us | The Redd Family Association',
    description:
      'Learn about The Redd Family Association, our history, mission, and the legacy we continue to build together.',
  },
  '/news': {
    title: 'News | The Redd Family Association',
    description:
      'Stay up to date with the latest news, announcements, and stories from The Redd Family Association.',
  },
  '/contact': {
    title: 'Contact Us | The Redd Family Association',
    description:
      'Get in touch with The Redd Family Association. Reach out for questions about membership, events, or family connections.',
  },
  '/officers': {
    title: 'Meet the Officers | The Redd Family Association',
    description:
      'Meet the dedicated officers and leaders of The Redd Family Association who help keep our family connected.',
  },
  '/login': {
    title: 'Sign In | The Redd Family Association',
    description:
      'Sign in to access the Redd Family Association member portal.',
  },
  '/register': {
    title: 'Join the Family | The Redd Family Association',
    description:
      'Register to become a member of The Redd Family Association and connect with your family.',
  },
  '/events': {
    title: 'Events | The Redd Family Association',
    description:
      'Upcoming family reunions, gatherings, and events from The Redd Family Association.',
  },
} as const;
